var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93938 13.0605L14.9394 22.0605C15.5256 22.6468 16.4743 22.6468 17.0605 22.0605C17.6468 21.4742 17.6468 20.5257 17.0605 19.9395L9.12113 12L17.0605 4.0605C17.0605 4.0605 17.0605 4.0605 17.0605 4.0605C17.6468 3.47424 17.6468 2.52571 17.0605 1.93945C16.4743 1.35319 15.5256 1.35319 14.9394 1.93945L5.93938 10.9395C5.64705 11.2318 5.49996 11.6165 5.49996 12C5.49996 12.3835 5.64705 12.7682 5.93938 13.0605Z",
    fill: "current",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledChevronLeft);
export default __webpack_public_path__ + "static/media/filledChevronLeft.21791797.svg";
export { ForwardRef as ReactComponent };